import { render, staticRenderFns } from "./TermsAcceptanceModal.vue?vue&type=template&id=86bc7fc6&scoped=true&"
import script from "./TermsAcceptanceModal.vue?vue&type=script&lang=ts&"
export * from "./TermsAcceptanceModal.vue?vue&type=script&lang=ts&"
import style0 from "./TermsAcceptanceModal.vue?vue&type=style&index=0&id=86bc7fc6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bc7fc6",
  null
  
)

export default component.exports